import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const STORAGE_KEY = 'growthly-cookie-consent';
export type CookieChoice = 'accepted' | 'rejected';
export function readCookieChoice(): CookieChoice | null {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === 'accepted' || stored === 'rejected' ? stored : null;
  } catch {
    return null;
  }
}
/**
 * Consentimiento de cookies acorde a lo que la web usa REALMENTE hoy:
 * almacenamiento técnico en el navegador (incluida esta misma preferencia).
 * No se declaran ni se cargan herramientas de analítica o publicidad porque
 * no están instaladas. Si en el futuro se añaden, sólo deben activarse cuando
 * `readCookieChoice() === 'accepted'`.
 */
export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (readCookieChoice() === null) setIsVisible(true);
  }, []);
  const decide = (choice: CookieChoice) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, choice);
    } catch {
      /* El almacenamiento puede estar bloqueado; la decisión sigue aplicándose en esta sesión. */
    }
    setIsVisible(false);
  };
  return <AnimatePresence data-id="element-32" data-mp="26fiy1d53gzra">
      {isVisible && <motion.aside initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} role="dialog" aria-live="polite" aria-label="Consentimiento de cookies" className="fixed inset-x-0 bottom-0 z-[60] border-t border-white/15 bg-black px-6 py-5 md:inset-x-auto md:bottom-6 md:left-6 md:max-w-md md:border" data-id="element-33" data-mp="2beccb7s7gusi">
          <h2 className="text-sm font-medium text-white" data-id="element-34" data-mp="3mszpdy06jdd6">
            Cookies y almacenamiento
          </h2>
          <p className="mt-2.5 text-[13px] leading-relaxed text-neutral-300" data-id="element-35" data-mp="3kg5k5lwndkye">
            Usamos almacenamiento técnico necesario para que la web funcione,
            incluida la memoria de esta preferencia. No cargamos cookies de
            analítica ni de publicidad sin tu consentimiento.
          </p>
          <div className="mt-4 flex flex-col gap-2.5 sm:flex-row" data-id="element-36" data-mp="36h5y8m0irk5x">
            <button type="button" onClick={() => decide('accepted')} className="h-11 flex-1 bg-white px-4 text-[13px] font-semibold text-black transition-colors hover:bg-neutral-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-37" data-mp="7y8s6ifnd4w2">
              Aceptar todo
            </button>
            <button type="button" onClick={() => decide('rejected')} className="h-11 flex-1 border border-white/25 px-4 text-[13px] font-semibold text-white transition-colors hover:border-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black" data-id="element-38" data-mp="qpianh7eb3zs">
              Rechazar no esenciales
            </button>
          </div>
          <Link to="/privacidad" className="mt-4 inline-block text-xs text-neutral-300 underline underline-offset-4 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-39" data-mp="139fb1w44rjj2">
            Más información en la Política de Privacidad
          </Link>
        </motion.aside>}
    </AnimatePresence>;
}